import { AbstractEventBus } from '@nab/x-events';
import { getAppMetaDataForInstanceId } from '../registries/instanceRegistry';
class RuntimeEventBus extends AbstractEventBus {
    getAppMetaDataForInstanceId(instanceId) {
        return getAppMetaDataForInstanceId(instanceId);
    }
}
export const runtimeEventBus = new RuntimeEventBus();
//# sourceMappingURL=runtimeEventBus.js.map